import { useEffect, useState } from 'react';
import { useContentActions } from '../../../../../modules/Disciplines/hooks/useContentActions';
import {
  dislikeMaterial,
  likeMaterial,
} from '../../../../../modules/Disciplines/queries/module';
import { useContentActionsContext } from '../../../../hooks/Contexts/useContentActionsContext';
import { Button } from '../../../atoms/Button';

export type TContentReview = 'like' | 'dislike';

interface IReviewButtonsProps {
  defaultReview?: TContentReview;
}

export function ReviewButtons({ defaultReview }: IReviewButtonsProps) {
  const { contentSlug, contentId, contentType } = useContentActionsContext();

  const [contentReview, setContentReview] = useState<
    'like' | 'dislike' | undefined
  >(defaultReview);

  const [actionLoading, setActionLoading] = useState<
    'like' | 'dislike' | 'none'
  >('none');

  const { onLikeContent, onDislikeContent } = useContentActions();

  async function handleLike() {
    setActionLoading('like');

    switch (contentType) {
      case 'Lesson':
        if (!contentSlug) return console.log('Content slug not found');
        await onLikeContent(contentSlug);
        break;
      case 'Material':
        if (!contentId) return console.log('Content id not found');
        await likeMaterial(contentId);
        break;
    }

    setContentReview('like');
    setActionLoading('none');
  }

  async function handleDislike() {
    setActionLoading('dislike');

    switch (contentType) {
      case 'Lesson':
        if (!contentSlug) return console.log('Content slug not found');
        await onDislikeContent(contentSlug);
        break;
      case 'Material':
        if (!contentId) return console.log('Content id not found');
        await dislikeMaterial(contentId);
        break;
    }

    setContentReview('dislike');
    setActionLoading('none');
  }

  useEffect(() => {
    setContentReview(defaultReview);
  }, [defaultReview]);

  return (
    <div className={'flex gap-sm'}>
      <Button
        onClick={handleLike}
        onlyIcon
        variant='text'
        size='regular'
        LeftIcon={'thumb_up'}
        iconType='material'
        iconVariant='rounded'
        className={'p-0'}
        classNameIcon={`w-6 h-6 text-mono-color-medium filled ${
          contentReview === 'like' ? ' text-brand-color-secondary-pure' : ''
        }`}
        loading={actionLoading === 'like'}
        disabled={contentReview === 'like'}
      />
      <Button
        onClick={handleDislike}
        onlyIcon
        variant='text'
        size='regular'
        LeftIcon={'thumb_down'}
        iconType='material'
        iconVariant='rounded'
        className={'p-0'}
        classNameIcon={`w-6 h-6 text-mono-color-medium filled ${
          contentReview === 'dislike' ? 'text-brand-color-secondary-pure' : ''
        }`}
        loading={actionLoading === 'dislike'}
        disabled={contentReview === 'dislike'}
      />
    </div>
  );
}
